import TagColumnBase from "./TagColumnBase";
import { ColumnStore } from "@bryntum/schedulerpro";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";

const storeKey = "taskTagValues";
class TaskTagsColumn extends TagColumnBase {
  static get $name() {
    return "TaskTagsColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnTaskTag;
  }

  static get defaults() {
    return this.defaultFilterableOptions;
  }

  get tagRecordKey() {
    return "_tags";
  }

  get storeKey() {
    return storeKey;
  }

  get tagKey() {
    return TAGS_KEYS.tag;
  }


  get swivuListTitle() {
    return "Task Tags";
  }

  get canMultiSelectSwivuList() {
    return true;
  }
}

class TaskStatusColumn extends TagColumnBase {
  static get $name() {
    return "TaskStatusColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnTaskStatus;
  }

  static get defaults() {
    return this.defaultFilterableOptions;
  }

  get tagRecordKey() {
    return "_status";
  }

  get storeKey() {
    return storeKey;
  }

  get tagKey() {
    return TAGS_KEYS.status;
  }


  get swivuListTitle() {
    return "Task Status";
  }
}

class TaskCategoryColumn extends TagColumnBase {
  static get $name() {
    return "TaskCategoryColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnTaskCategory;
  }

  static get defaults() {
    return this.defaultFilterableOptions;
  }

  get tagRecordKey() {
    return "_category";
  }

  get storeKey() {
    return storeKey;
  }

  get tagKey() {
    return TAGS_KEYS.category;
  }



  get swivuListTitle() {
    return "Task Category";
  }
}

class TaskPhaseColumn extends TagColumnBase {
  static get $name() {
    return "TaskPhaseColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnTaskPhase;
  }

  static get defaults() {
    return this.defaultFilterableOptions;
  }

  get tagRecordKey() {
    return "_phase";
  }

  get storeKey() {
    return storeKey;
  }

  get tagKey() {
    return TAGS_KEYS.phase;
  }


  get swivuListTitle() {
    return "Task Phase";
  }
}

ColumnStore.registerColumnType(TaskCategoryColumn);
ColumnStore.registerColumnType(TaskStatusColumn);
ColumnStore.registerColumnType(TaskTagsColumn);
ColumnStore.registerColumnType(TaskPhaseColumn);
